import {
  LOAD_WEBSITE_TAGS,
  LOAD_WEBSITE_TAGS_FAIL,
  LOAD_WEBSITE_TAGS_SUCCESS,
  LoadWebsiteTags,
  LoadWebsiteTagsFail,
  LoadWebsiteTagsSuccess
} from '../actions/website-tags.action';
import {WebsiteTagsAction} from "../actions";

export interface IWebsiteTagsEntityState {
  entities: {};
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteTagsState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export const initialState: IWebsiteTagsState = {
  entities: {},
  loading: false,
  loaded: false};

export function reducer(state: IWebsiteTagsState = initialState, action: WebsiteTagsAction): IWebsiteTagsState {
  let payload: any;

  switch (action.type) {

    case LOAD_WEBSITE_TAGS:
      payload = (<LoadWebsiteTags>action);

      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_WEBSITE_TAGS_SUCCESS:
      payload = (<LoadWebsiteTagsSuccess>action).payload;
      return {
        ...state,
        entities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_WEBSITE_TAGS_FAIL:
      payload = (<LoadWebsiteTagsFail>action).payload;

      return {
        ...state,
        loading: false,
        loaded: true
      };

  }

  return state;
}
